<template>
  <div class="home-page">
    <section class="hero">
      <div class="hero-copy">
        <p class="kicker">卓煜鑫电子 · 嵌入式硬件方案</p>
        <h1>让每一寸电路，<br>成为可见的智能。</h1>
        <p class="lead">电路板制造与智能显示终端，服务从设计验证到批量交付。</p>
        <div class="actions">
          <router-link class="button copper" to="/products">查看产品 <span>↘</span></router-link>
          <router-link class="button outline" to="/contact">预约方案咨询</router-link>
        </div>
      </div>
      <div class="hero-media" aria-hidden="true">
        <img class="hero-image" :src="hero" alt="">
      </div>
    </section>

    <section class="product-stages">
      <article class="stage board-stage">
        <img :src="pcbStage" alt="工业电路板">
        <div class="stage-copy">
          <p>01 / 电路板制造</p>
          <h2>从复杂布线<br>到稳定量产。</h2>
          <router-link to="/products">PCB 方案 <span>→</span></router-link>
        </div>
      </article>
      <article class="stage terminal-stage">
        <img :src="displayStage" alt="智能显示终端">
        <div class="stage-copy">
          <p>02 / 智能显示终端</p>
          <h2>让设备拥有清晰、<br>可靠的交互界面。</h2>
          <router-link to="/products">屏幕方案 <span>→</span></router-link>
        </div>
      </article>
    </section>

    <section class="capability">
      <div class="section-intro">
        <p class="kicker">制造协作</p>
        <h2>从设计验证到批量交付</h2>
      </div>
      <ol class="process">
        <li v-for="(step, index) in steps" :key="step"><span>0{{ index + 1 }}</span><b>{{ step }}</b></li>
      </ol>
      <div class="inspection">
        <img :src="inspection" alt="电路板检测">
        <p>围绕产品定义、样品验证与量产交付建立协作节奏，让复杂硬件项目保持清晰推进。</p>
      </div>
    </section>

    <section class="applications">
      <article>
        <img :src="industrialControl" alt="工控自动化">
        <div><p>解决方案 / 智能制造</p><h2>工控自动化</h2><span>面向工厂自动化、数控机床与远程监控系统。</span><router-link to="/solutions">查看方案 <b>→</b></router-link></div>
      </article>
      <article>
        <img :src="commercialTerminal" alt="机器视觉">
        <div><p>解决方案 / 智能制造</p><h2>机器视觉</h2><span>以图像采集、分析和控制执行支持检测与机器人视觉。</span><router-link to="/solutions">查看方案 <b>→</b></router-link></div>
      </article>
    </section>

    <section class="contact-callout">
      <p class="kicker">项目咨询</p>
      <h2>有一个项目正在启动？</h2>
      <p>告诉我们产品目标与使用场景，由方案工程师跟进。</p>
      <router-link class="button copper" to="/contact">提交需求 <span>→</span></router-link>
    </section>
  </div>
</template>

<script>
import hero from '@/assets/home/hero-concept.png'
import pcbStage from '@/assets/home/pcb-stage-concept.png'
import displayStage from '@/assets/home/display-stage-concept.png'
import inspection from '@/assets/home/inspection-concept.png'
import industrialControl from '@/assets/home/industrial-control-concept.png'
import commercialTerminal from '@/assets/home/commercial-terminal-concept.png'

export default {
  name: 'ModernHome',
  data () {
    return {
      hero,
      pcbStage,
      displayStage,
      inspection,
      industrialControl,
      commercialTerminal,
      steps: ['需求沟通', '设计验证', '样品试制', '批量交付', '持续服务']
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page { background: #f4f6f4; }
.hero { position: relative; display: flex; align-items: center; min-height: 100vh; padding: 155px 8vw 92px; overflow: hidden; color: #f4f6f4; background: #111719; isolation: isolate; }
.hero-copy { position: relative; z-index: 2; width: min(620px, 50%); }
.kicker { margin: 0 0 23px; color: #d68a5d; font-family: 'IBM Plex Mono', monospace; font-size: 11px; letter-spacing: .12em; }
h1, h2, p { margin-top: 0; }
.hero h1 { margin-bottom: 29px; font-size: clamp(46px, 5.25vw, 78px); line-height: 1.13; letter-spacing: -.065em; }
.lead { max-width: 390px; margin-bottom: 34px; color: rgba(244, 246, 244, .74); font-size: 17px; line-height: 1.8; }
.actions { display: flex; gap: 12px; }
.button { display: inline-flex; align-items: center; justify-content: center; min-height: 50px; padding: 0 22px; font-size: 15px; transition: .25s ease; }
.button span { margin-left: 10px; }.copper { color: #fff; background: #c76b3a; }.copper:hover { background: #dc7a43; }.outline { border: 1px solid rgba(244,246,244,.58); color: #fff; }.outline:hover { color: #111719; background: #f4f6f4; }
.hero-media { position: absolute; z-index: -1; inset: 0; overflow: hidden; }.hero-image { width: 100%; height: 100%; object-fit: cover; object-position: center; }
.product-stages, .applications { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; padding: 12px; background: #111719; }.stage { position: relative; height: 520px; overflow: hidden; }.stage > img { width: 100%; height: 100%; object-fit: cover; transition: transform .7s ease; }.stage:hover > img, .applications article:hover img { transform: scale(1.035); }.board-stage { color: #f4f6f4; background: #1b2326; }.board-stage > img { filter: saturate(.62) contrast(1.08) brightness(.44); }.terminal-stage { color: #f4f6f4; background: #171d1f; }.terminal-stage > img { object-position: 78% center; filter: brightness(.51) saturate(.55); }.stage-copy { position: absolute; right: 8%; bottom: 48px; left: 8%; }.stage-copy p, .applications article div p { margin-bottom: 18px; font-family: 'IBM Plex Mono', monospace; font-size: 11px; letter-spacing: .09em; opacity: .72; }.stage-copy h2 { margin-bottom: 24px; font-size: clamp(32px, 3.1vw, 48px); line-height: 1.18; letter-spacing: -.05em; }.stage-copy a { color: #d68a5d; font-size: 15px; font-weight: 600; }.stage-copy a span { margin-left: 7px; }
.capability { padding: 138px 8vw 0; color: #111719; }.section-intro h2 { margin-bottom: 0; font-size: clamp(38px, 4vw, 60px); line-height: 1.15; letter-spacing: -.06em; }.process { display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px; margin: 86px 0 82px; padding: 0; list-style: none; }.process li { position: relative; padding-top: 28px; border-top: 1px solid #c76b3a; }.process li:before { position: absolute; top: -6px; left: 0; width: 10px; height: 10px; border: 2px solid #f4f6f4; border-radius: 50%; background: #c76b3a; content: ''; }.process span { display: block; margin-bottom: 11px; color: #9d5736; font-family: 'IBM Plex Mono', monospace; font-size: 11px; }.process b { font-size: 17px; }.inspection { display: grid; grid-template-columns: 1.55fr .85fr; align-items: end; gap: 8vw; }.inspection img { width: 100%; height: 420px; object-fit: cover; filter: saturate(.8) contrast(1.1); }.inspection p { margin: 0 0 58px; font-size: 18px; line-height: 1.9; }
.applications { background: #f4f6f4; }.applications article { position: relative; min-height: 590px; overflow: hidden; color: #fff; }.applications img { width: 100%; height: 100%; object-fit: cover; filter: brightness(.5) saturate(.56); transition: transform .7s ease; }.applications article div { position: absolute; right: 10%; bottom: 48px; left: 10%; }.applications h2 { margin-bottom: 10px; font-size: 42px; letter-spacing: -.05em; }.applications span { color: rgba(255,255,255,.76); font-size: 16px; }
.contact-callout { display: flex; min-height: 530px; flex-direction: column; align-items: center; justify-content: center; padding: 86px 24px; overflow: hidden; color: #f4f6f4; text-align: center; background: #111719; background-image: linear-gradient(90deg, rgba(199,107,58,.14) 1px, transparent 1px), linear-gradient(rgba(199,107,58,.1) 1px, transparent 1px); background-size: 21px 21px; }.contact-callout h2 { margin-bottom: 22px; font-size: clamp(40px, 4.5vw, 64px); letter-spacing: -.06em; }.contact-callout > p:not(.kicker) { margin-bottom: 32px; color: rgba(244,246,244,.7); font-size: 16px; }
@media (max-width: 760px) { .hero { min-height: 710px; align-items: flex-start; padding: 142px 24px 60px; }.hero-copy { width: 100%; }.hero h1 { font-size: 42px; }.lead { max-width: 300px; font-size: 15px; }.actions { flex-direction: column; align-items: flex-start; }.hero-image { object-position: 62% center; }.product-stages, .applications { grid-template-columns: 1fr; gap: 6px; padding: 6px; }.stage { height: 430px; }.stage-copy { right: 26px; bottom: 32px; left: 26px; }.stage-copy h2 { margin-bottom: 18px; font-size: 34px; }.capability { padding: 88px 24px 0; }.section-intro h2 { font-size: 39px; }.process { grid-template-columns: 1fr; gap: 0; margin: 54px 0; }.process li { display: grid; grid-template-columns: 42px 1fr; align-items: center; min-height: 58px; padding: 0 0 0 20px; border-top: 0; border-left: 1px solid #c76b3a; }.process li:before { top: 24px; left: -6px; }.process span { margin: 0; }.inspection { display: flex; flex-direction: column; gap: 0; }.inspection img { height: 300px; }.inspection p { margin: 32px 0 56px; font-size: 16px; }.applications article { min-height: 440px; }.applications h2 { font-size: 34px; }.contact-callout { min-height: 470px; }.contact-callout h2 { font-size: 43px; } }
</style>
